import { makeObservable, observable, action, runInAction } from "mobx";
import axios from "../config/axios";

class NotificationsStore {
  notifications = [];

  isLoadingNotifications = false;

  constructor() {
    makeObservable(this, {
      notifications: observable.ref,
      isLoadingNotifications: observable.ref,

      getNotifications: action,
      updateNotification: action,
    });
  }

  getNotifications = () => {
    runInAction(() => {
      this.isLoadingNotifications = true;
    });
    axios
      .get("api/license-notifications/")
      .then(({ data }) => {
        console.log('RES: ', data)
        runInAction(() => {
          this.notifications = data;
          this.isLoadingNotifications = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingNotifications = false;
        });
      });
  };


  updateNotification = () => {
    runInAction(() => {
      this.isLoadingNotifications = true;
    });
    axios
      .post("api/license-notifications/")
      .then(({ data }) => {
        console.log('res: ', data)
        runInAction(() => {
          this.notifications = [];
          this.isLoadingNotifications = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingNotifications = false;
        });
      });
  };
}

export default new NotificationsStore();
